import { render } from "./SignWrapPeercoin.vue?vue&type=template&id=7718ff45&scoped=true"
import script from "./SignWrapPeercoin.vue?vue&type=script&lang=js"
export * from "./SignWrapPeercoin.vue?vue&type=script&lang=js"

import "./SignWrapPeercoin.vue?vue&type=style&index=0&id=7718ff45&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7718ff45"]])

export default __exports__